var TriggerOperator = /* @__PURE__ */ ((TriggerOperator2) => {
  TriggerOperator2[TriggerOperator2["equals"] = 0] = "equals";
  TriggerOperator2[TriggerOperator2["notEquals"] = 1] = "notEquals";
  return TriggerOperator2;
})(TriggerOperator || {});
export {
  TriggerOperator
};
//# sourceMappingURL=StudyTemplate.js.map
